'use strict';

angular.module('uniromaLandingApp').controller('RejectedTypeDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'RejectedType',
        function($scope, $stateParams, $modalInstance, entity, RejectedType) {

        $scope.rejectedType = entity;
        $scope.load = function(id) {
            RejectedType.get({id : id}, function(result) {
                $scope.rejectedType = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:rejectedTypeUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.rejectedType.id != null) {
                RejectedType.update($scope.rejectedType, onSaveFinished);
            } else {
                RejectedType.save($scope.rejectedType, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);
